import { ILicenceApplicationTrackerProps } from "./ILicenceApplicationTrackerProps";
import { LicenceApplicationStatuses } from "../../../../../api/LicenceDetails";
import { Row } from "react-bootstrap";

export const TrackerText = ({
  licence,
  licenceProfile,
}: ILicenceApplicationTrackerProps) => {
  let el: JSX.Element = <p></p>;
  switch (licence.lastatus) {
    case LicenceApplicationStatuses.ApplicationReceived:
      el = (
        <p>
          A licence application has been submitted to the EPA and is awaiting an
          initial assessment to determine completeness
        </p>
      );
      break;
    case LicenceApplicationStatuses.UnderAssessment:
      el = (
        <p>
          The EPA is currently assessing the application and any additional
          information received.
        </p>
      );
      break;
    case LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding:
      el = (
        <p>
          Following an initial assessment, the EPA has requested additional
          information from the Applicant. The application will proceed once the
          requested information is received.
        </p>
      );
      break;
    case LicenceApplicationStatuses.ApplicationCompliance:
      el = (
        <p>
          The application and all supporting information has been assessed and
          is considered compliant with the relevant regulatory requirements.
        </p>
      );
      break;
    case LicenceApplicationStatuses.ProposedDeterminationIssued:
      el = (
        <p>
          A Proposed Determination has been issued and is currently open to
          objections from the applicant or third parties, within the applicable
          statutory timeframe
        </p>
      );
      break;
    case LicenceApplicationStatuses.ConsiderationofObjections:
      el = (
        <p>
          Where objections are received, they are being considered by the EPA as
          part of the decision-making process. If no objections are received,
          the application proceeds to Final Determination in line with statutory
          requirements.
        </p>
      );
      break;
    case LicenceApplicationStatuses.AuthorisationIssued:
      el = (
        <p>
          A Final Determination, subject to conditions, has been issued to the
          applicant.
        </p>
      );
      break;
  }
  return <Row style={{ marginTop: "20px" }}>{el}</Row>;
};
